import { Colors } from 'libs/ui/theme';

import { SvgIcon } from '../SvgIcon';
import { SvgProps } from '../types';

export const Lock = ({
  size = 24,
  color = Colors.black,
  className,
}: SvgProps) => (
  <SvgIcon className={className} size={size}>
    <svg
      color={color}
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33398 6V4.66667C5.33398 3.19391 6.52789 2 8.00065 2C9.47341 2 10.6673 3.19391 10.6673 4.66667V6M5.46732 14H10.534C11.2807 14 11.6541 14 11.9393 13.8547C12.1902 13.7268 12.3942 13.5229 12.522 13.272C12.6673 12.9868 12.6673 12.6134 12.6673 11.8667V8.13333C12.6673 7.3866 12.6673 7.01323 12.522 6.72801C12.3942 6.47713 12.1902 6.27316 11.9393 6.14532C11.6541 6 11.2807 6 10.534 6H5.46732C4.72058 6 4.34721 6 4.062 6.14532C3.81111 6.27316 3.60714 6.47713 3.47931 6.72801C3.33398 7.01323 3.33398 7.3866 3.33398 8.13333V11.8667C3.33398 12.6134 3.33398 12.9868 3.47931 13.272C3.60714 13.5229 3.81111 13.7268 4.062 13.8547C4.34721 14 4.72058 14 5.46732 14Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
    </svg>
  </SvgIcon>
);
